import { apiFactory } from "../api_factory";

export const floorsApi = apiFactory({
  path: "/api/v4/facility-floors"
});
